(function () {
  'use strict';
  var dialog = document.getElementById('smf-b2b-dialog');
  var form = document.getElementById('smf-b2b-form');
  if (!dialog || !form || dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  var audience = dialog.dataset.audience || 'b2b';
  var isRetail = audience === 'retail';
  var formName = isRetail ? 'manufacturer_retail_enquiry' : (audience === 'projects' ? 'hospitality_architect_enquiry' : 'manufacturer_b2b_enquiry');
  var submitLabel = submitLabelForAudience();
  function submitLabelForAudience() { return isRetail ? 'Send partner enquiry' : (audience === 'projects' ? 'Send project enquiry' : 'Send B2B enquiry'); }
  var API = 'https://os.saunamo.pt/api/popup-form';
  var SEND_TO = 'AW-11139109502/bg9oCNur3JYdEP6kxb8p';
  var pending = false, complete = false, opener = null, previousOverflow = '';
  var submissionId = crypto.randomUUID();
  var submit = form.querySelector('[type="submit"]');
  var error = document.getElementById('b2b-error');
  var success = document.getElementById('b2b-success');
  function value(name) { return String(form.elements.namedItem(name).value || '').trim(); }
  function open(button) {
    opener = button;
    if (button.dataset.b2bRole && !complete) {
      form.elements.namedItem('business_type').value = button.dataset.b2bRole;
      form.elements.namedItem('project_type').value = isRetail ? 'Retail / reseller partnership' : 'Reseller / trade partnership';
    }
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-b2b-open]');
    // Keep the storefront's header quote action on the same B2B enquiry path.
    if (!button && event.target.closest('header, .header-wrapper')) {
      button = event.target.closest('.indentOrcBtn, a[href="#indentPopup"], [aria-label="Request quote"]');
    }
    if (button) { event.preventDefault(); event.stopImmediatePropagation(); open(button); }
    if (event.target.closest('[data-b2b-close]')) dialog.close();
  }, true);
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) {
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', function () {
    document.body.style.overflow = previousOverflow;
    if (opener) opener.focus();
  });
  function attribution() {
    var tracker = window.saunamoCampaignTracking;
    var result = tracker ? tracker.read() : {};
    delete result._gl; // Browser linker tokens are not CRM attribution.
    result.form_name = formName;
    result.b2b_audience = audience;
    result.lead_type = 'b2b';
    result.landing_page = location.href.split('#')[0];
    result.ads_data_consent = 'denied';
    try { if (tracker && tracker.allowed()) result.ads_data_consent = 'granted'; } catch (_) {}
    return result;
  }
  function payload() {
    var business = value('business_name'), role = value('business_type'), project = value('project_type');
    return {
      step: 1, submission_id: submissionId,
      name: value('name'), email: value('email'), phone: value('phone'), location: value('location'),
      company: value('company'), // Existing intake's honeypot, never the actual business name.
      lang: 'en', page_url: location.href.split('#')[0],
      theme_id: window.Shopify && Shopify.theme ? Shopify.theme.id : null,
      theme_role: window.Shopify && Shopify.theme ? Shopify.theme.role : null,
      is_preview_theme: new URLSearchParams(location.search).has('preview_theme_id'),
      product_name: isRetail ? 'Retail / showroom / reseller partnership' : 'Hospitality / architect sauna project',
      selected_products: [project],
      message: [isRetail ? 'SAUNAMO RETAIL PARTNER ENQUIRY' : 'SAUNAMO HOSPITALITY / ARCHITECT ENQUIRY','Company: '+business,'Business type / role: '+role,'Website / portfolio: '+(value('website') || 'Not provided'),'Enquiry type: '+project,'Target timeline: '+(value('timeline') || 'To be discussed'),'Contact permission: enquiry follow-up accepted',isRetail ? 'Business and product interests:' : 'Project brief:',value('brief')].join('\n'),
      attribution: attribution()
    };
  }
  async function post(body) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 25000);
    try {
      var response = await fetch(API, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:controller.signal});
      var data = await response.json();
      if (!response.ok || !data.success || !data.deal_id) throw new Error('intake-not-accepted');
      return data;
    } finally { clearTimeout(timer); }
  }
  function track(data) {
    if (data.os_sync_skipped || data.notification_suppressed || String(data.deal_id).indexOf('suppressed-') === 0) return;
    if (window.saunamoCampaignTracking && window.saunamoCampaignTracking.blocked()) return;
    var transactionId = String(data.deal_id)+':b2b';
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    // The live theme already loads this Google Ads tag. Queue safely if still loading.
    try { window.gtag('event','conversion',{send_to:SEND_TO,value:1,currency:'EUR',transaction_id:transactionId}); } catch (_) {}
    try { window.dataLayer.push({event:'b2b_enquiry_submitted',form_name:formName,b2b_audience:audience,lead_type:'b2b',transaction_id:transactionId}); } catch (_) {}
  }
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (pending || complete || !form.reportValidity()) return;
    pending = true; submit.disabled = true; submit.textContent = 'Sending your enquiry…'; error.hidden = true;
    var body = payload();
    try {
      var data = await post(body);
      // All business and project details were durably accepted in step 1.
      // Completion enriches the same lead; it never creates a second conversion.
      complete = true;
      form.hidden = true; success.hidden = false;
      if (data.os_sync_skipped || String(data.deal_id).indexOf('suppressed-') === 0) {
        document.getElementById('b2b-success-text').textContent = 'Test completed successfully. No sales lead, notification or advertising conversion was created.';
      }
      dialog.scrollTop = 0;
      success.querySelector('button').focus();
      // Advertising and optional enrichment cannot change an accepted receipt.
      try { track(data); } catch (_) {}
      post(Object.assign({},body,{step:2,person_id:data.person_id,deal_id:data.deal_id})).catch(function () {});
    } catch (_) {
      error.textContent = 'We could not confirm your enquiry. Please try again, or email info@saunamo.shop with your project details.';
      error.hidden = false; error.scrollIntoView({block:'nearest'});
    } finally {
      pending = false; submit.disabled = false; submit.textContent = submitLabel;
    }
  });
})();
